// Moldura de uma secção da página inicial: título, frase e (opcional) um fundo pintado do jogo, esbatido.
import type { ReactNode } from "react";

export function Section({ id, title, lead, bg, children }: { id: string; title: ReactNode; lead?: ReactNode; bg?: string; children: ReactNode }) {
  return (
    <section id={id} className="relative scroll-mt-16 px-4 py-20 sm:px-[6vw] sm:py-24">
      {bg && <img src={bg} alt="" aria-hidden loading="lazy" decoding="async" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.18]" />}
      <div className="relative">
        <h2 className="mb-2 text-center text-[clamp(28px,4vw,44px)] font-extrabold text-gold">{title}</h2>
        {lead && <p className="mx-auto mb-9 max-w-3xl text-center text-lg text-muted-foreground">{lead}</p>}
        {children}
      </div>
    </section>
  );
}

/** Painel translúcido com borda dourada (o "cartão" das secções do site). */
export function Panel({ className = "", children }: { className?: string; children: ReactNode }) {
  return <div className={`skin-panel-soft rounded-xl border bg-card ${className}`}>{children}</div>;
}
